<template>
  <div class="row ml-2 mb-5" v-if="form.data.value_type">
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-3">Product Selection</h4>
      <product-search-tab
        :form="form"
        :products="form.data._entitled_products"
        :viewOnly="viewOnly"
        :forDiscountedAmount="true"
        :viewTabName="'Configure discounts'"
        :sales_channel_stores="form.sales_channel_stores"
      ></product-search-tab>
    </div>
    <div class="d-none">{{validationErrors}}</div>
  </div>
  <div v-else></div>
</template>
<script>
  import ProductSearchTab from './ProductSearchTab'

  export default {
    props: {
      form: Object,
      promotion: Object,
      viewOnly: Boolean
    },
    components: {
      ProductSearchTab
    },
    name: "discounted-amount",
    methods: {
      validatePromotion: function(){
        let errors = []
        let data = this.form.data
        this.form.data.validationErrors = []

        if(data._entitled_products.length === 0)
          errors.push("Add atleast one product line discount")

        this.form.data.validationErrors = errors
        return errors
      }
    },
    computed: {
      validationErrors: function () {
        return this.validatePromotion()
      }
    },
    mounted: function(){
      let starts_at = new Date()
      let ends_at = new Date()
      ends_at = new Date(ends_at.setMonth(ends_at.getMonth() + 1))
      this.form.data = {
        ...{
          title: this.form.code,
          value_type: 'discount_amount',
          _entitled_products: [],
          starts_at: starts_at.toDateString(),
          ends_at: ends_at.toDateString(),
          _ends_at: true,
          validationErrors: []
        },
        ...this.form.data
      }
    }
  }
</script>
